export default __webpack_public_path__ + "static/media/LightBlue0003.19ff3db1.png";